import React from "react";
import { GameBrand } from "@precisionpros/game-ui";

const game = {
  name: "Connect",
  wordmarkMain: "Connect",
  wordmarkAccent: "Pro",
  badge: "C",
  accent: "#2563eb",
};

export default function ConnectProBrand({ size = "header", markOnly = false, className = "" }) {
  return <GameBrand game={game} size={size} markOnly={markOnly} className={className} />;
}

export { game as connectProGame };
